var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F54100",
    d: "M12 15c-.553 0-1-.503-1-1.125v-6.75C11 6.503 11.447 6 12 6c.553 0 1 .503 1 1.125v6.75c0 .622-.447 1.125-1 1.125m1.503 3.5c0 .828-.673 1.5-1.503 1.5-.83 0-1.503-.672-1.503-1.5S11.17 17 12 17c.83 0 1.503.672 1.503 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F54100",
    strokeLinejoin: "round",
    d: "M14.195 2.98l8.63 15.823a2.5 2.5 0 01-2.194 3.697H3.369a2.5 2.5 0 01-2.195-3.697L9.805 2.98a2.499 2.499 0 014.39 0z"
  }))));
}
SvgWarningTriangle.displayName = 'WarningTriangle';
export default SvgWarningTriangle;